// skb`s func
const store = require('../store/index')
export default {
    install(Vue) {
        /**
         * 挂载一个动态添加实例data中对象的属性的方法到Vue原型上
         * data:待添加的新对象
         * object:实例的data中已经声明的对象
         */
        /**
         * time 时间对象
         * tag 传入想要得到的时间格式 yyyy-MM-dd HH-mm-ss
         */
        Vue.prototype.$tagTime = (time, tag) => {
                if (!tag) {
                    return ""
                }
                if (!time) {
                    return ""
                }
                let tmpTime = new Date(time)
                if (isNaN(tmpTime)) {
                    return ""
                }
                let year = tmpTime.getFullYear(),
                    month = tmpTime.getMonth() + 1,
                    date = tmpTime.getDate(),
                    hour = tmpTime.getHours(),
                    minute = tmpTime.getMinutes(),
                    second = tmpTime.getSeconds()
                    // 不足10前面补0
                if (month < 10) {
                    month = "0" + month
                }
                // 不足10前面补0
                if (date < 10) {
                    date = "0" + date
                }
                // 不足10前面补0
                if (hour < 10) {
                    hour = "0" + hour
                }
                // 不足10前面补0
                if (minute < 10) {
                    minute = "0" + minute
                }
                // 不足10前面补0
                if (second < 10) {
                    second = "0" + second
                }
                return tag.replace("yyyy", year).replace("MM", month).replace("dd", date).replace("HH", hour).replace("mm", minute).replace("ss", second)
            },
        Vue.prototype.$download = (params, url) => {
            axios({
                method: 'post',
                url: url,
                data: params,
                responseType: 'blob'
            }).then(res => {
                let r = new FileReader()
                r.onload = function() {
                    try {
                        //不是对象，返回文件流json会报语法错误
                        let jsonData = JSON.parse(this.result);
                        if (jsonData.code != 200) {
                            Message.error(jsonData.msg)
                        }
                    } catch (err) {
                        // 解析成对象失败，说明是正常的文件流
                        let fileName = res.headers['content-disposition'] ? '' + res.headers['content-disposition'].split('=')[1].toString() : ''
                        if (!res) {
                            return
                        }
                        let url = window.URL.createObjectURL(new Blob([res.data]))
                        let link = document.createElement('a')
                        link.style.display = 'none'
                        link.href = url
                        link.setAttribute('download', decodeURIComponent(fileName))
                        document.body.appendChild(link)
                        link.click()
                    }
                }
                r.readAsText(res.data)
            }).catch(err => {
                console.log(err, 'err')
            })
        };

        // 设置表头颜色的方法
        Vue.prototype.$tableHeaderColor = ({
                rowIndex
            }) => {
                if (rowIndex == 0) {
                    return "background-color:#f2f2f2;font-weight:500";
                }
            }
        // 按钮权限测试
        Vue.prototype.$btnAuthorityTest = key => {
            let btnList = store.default.getters.getBtnAuthorityList
            return btnList.includes(key)
        };
    },
}


// WEBPACK FOOTER //
// ./src/utils/globalFunc.js